export const tablasMixin = {
	data: function() {
		return {
			tableProps: {
				border: true,
				stripe: true,
				defaultSort: {
					prop: undefined,
					order: 'descending'
				},
				//highlightCurrentRow: true,
				rowClassName({ row, rowIndex }) {
					return 'estiloFilaTabla';
				}
			}
		}
	},
	methods:{
		formatPieTotalTabla(tabla){
            tabla.$el.querySelector(".el-table__footer").style.cssText += " font-weight:bold;";
            var v_lista = tabla.$el.querySelector(".el-table__footer").querySelectorAll(".cell");
            v_lista.forEach(function(Item) {
                if(Item.innerHTML!='Total')
                Item.style.cssText += " text-align:right !Important;";
            });
        }
	}
};
